import { ApplicantType } from "shared/types";
import { ApplicantRoleLabel } from "shared/utils";
import { getReportLabel } from "shared/app/UnderwritingAgents/rules";
import {
  NeedsReviewBadge,
  ReviewedBadge
} from "shared/app/UnderwritingAgents/findings/FindingCard";
import { UnderwritingAgentCheckCompletedActivity } from "../types";

/** An underwriting agent finished checking a report: what it flagged and whether each has been reviewed since. */
export const UnderwritingAgentCheckCard = ({
  activity
}: {
  activity: UnderwritingAgentCheckCompletedActivity;
}) => {
  const { details, author } = activity;
  const findings = details.findings ?? [];
  const agentName = author?.name || "Underwriting agent";

  return (
    <div className="w-full space-y-3">
      <p className="text-base font-bold text-content-1000">
        {agentName} reviewed {getReportLabel(details.report_key)}
      </p>

      {findings.length ? (
        <div className="space-y-3 rounded-lg bg-background-900 p-4">
          {findings.map((finding) => (
            <div key={finding.id} className="space-y-2">
              {finding.reviewed_at ? (
                <ReviewedBadge label="Reviewed" />
              ) : (
                <NeedsReviewBadge label="Needs review" />
              )}
              <p className="text-sm font-medium text-content-700">
                {finding.finding}
              </p>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-sm text-content-400">Nothing was flagged.</p>
      )}

      <div className="flex items-center justify-between text-sm text-content-400">
        {details.applicant_name ? (
          <span>
            {
              ApplicantRoleLabel[
                details.applicant_role || ApplicantType.Applicant
              ]
            }
            : <span className="font-medium">{details.applicant_name}</span>
          </span>
        ) : null}
        <span>
          Agent: <span className="font-medium">{agentName}</span>
        </span>
      </div>
    </div>
  );
};
